import {common_utils} from "../common/common_utils";
import {game_2002_2004} from "./game_2002_2004";

function game_2005()
{

}
game_2005.getWinInfo = function(obj)
{
  let winInfo = "";
  if(common_utils.isNull(obj))
  {
    return winInfo;
  }

  let index = 0;
  let winValue = 0;
  Object.keys(obj).map(function(key) {
    let subitem = obj[key];
    let bet = 0;
    if(subitem.bet)
    {
      bet = subitem.bet;
    }
    if(subitem.win > 0)
    {
      if(index > 0)
      {
        winInfo += " + ";
      }
      winInfo += ((subitem.win - bet) / 100).toFixed(2)
      winValue += subitem.win-bet;
    }
    else
    {

      if(bet>0)
      {
        winInfo += " - ";
      }
      else
      {
        if(index > 0)
        {
          winInfo += " + ";
        }
      }
      winValue += - bet;
      winInfo += (bet / 100).toFixed(2);
    }
    index++;
  });
  winInfo += " = " +(winValue / 100).toFixed(2);
  return winInfo;
}

export {
  game_2005
};



// WEBPACK FOOTER //
// ./src/components/joker/game_2005.js